module.exports = __webpack_public_path__ + "img/mobile-anti-drooling-middle.cf521014.png";